export const DEFAULT_API_URL =
  process.env.REACT_APP_API_URL_VR_EDITOR || "http://localhost:3001";
// export const DEFAULT_API_URL = 'http://localhost:3001';
export function analyticsBaseUrl(value = DEFAULT_API_URL) {
  const base = (typeof value === "string" ? value : DEFAULT_API_URL)
    .trim()
    .replace(/\/+$/, "");
  return base.endsWith("/tournaments-analytics")
    ? base
    : `${base}/tournaments-analytics`;
}
export const endpoints = {
  leaderboard: ["/teams/leaderboard", "Ranking szkół"],
  players: ["/teams/mvp", "Uczestnicy"],
  progress: ["/puzzles/progress", "Postęp puzzli"],
  cooperation: ["/teams/coop-score", "Współpraca"],
  games: ["/puzzles/completion-time", "Minigry"],
  rooms: ["/escape-room/analytics", "Escape roomy"],
  dropoff: ["/puzzles/dropoff", "Aktywność puzzli"],
};

export const gameNames = {
  exe_booth_minigame_climbing_course: "Tor wspinaczkowy",
  exe_booth_minigame_cups_shuffle: "Gra w 3 kubki",
  exe_minigame_cups_shuffle: "Gra w 3 kubki",
  exe_booth_minigame_globe: "Gdzie to jest?",
  exe_booth_minigame_quiz: "Trivia",
  exe_booth_minigame_rythm: "Muzyczny Refleks",
  exe_minigame_shapes: "Cztery Kształty",
  exe_minigame_space_invaders: "Kosmiczny tor przeszkód",
  exe_booth_minigame_sudoku: "Sudoku",
  exe_booth_minigame_woodwork: "Wyzwanie Stolarza",
  exe_minigame_whack_a_mole: "Pacnij Kreta",
  exe_booth_negotiations_1: "Negocjacje · Solaris Energia",
  exe_booth_negotiations_2: "Negocjacje · Heliofutura",
  exe_booth_negotiations_3: "Negocjacje · Solara",
};
export const roomNames = {
  edu_vr_cup_leader: "Lider",
  edu_vr_cup_negotiations: "Negocjacje",
  edu_vr_cup_civil_def: "Obrona cywilna",
  edu_vr_cup_full: "Czas końcowy",
};
export const number = (value) =>
  value === null ||
  value === undefined ||
  (typeof value === "string" && !value.trim()) ||
  !Number.isFinite(Number(value))
    ? null
    : Number(value);
export const format = (value, digits = 0) =>
  number(value) === null
    ? "—"
    : Number(value).toLocaleString("pl-PL", { maximumFractionDigits: digits });
export const percent = (value) =>
  number(value) === null ? "—" : `${format(value * 100, 1)}%`;
export function duration(value, divisor = 1) {
  const n = number(value);
  if (n === null || n < 0) return "—";
  const seconds = Math.round(n / divisor);
  return `${Math.floor(seconds / 60)} min ${String(seconds % 60).padStart(2, "0")} s`;
}
export const teamId = (row) => row.teamId ?? row.team_id;
export function buildModel(data) {
  const teams = new Map();
  const ensure = (row) => {
    const raw = teamId(row);
    if (raw === undefined || raw === null) return null;
    const id = String(raw);
    if (!teams.has(id))
      teams.set(id, { id, name: `Drużyna ${id}`, players: [] });
    const team = teams.get(id);
    if (row.teamName || row.team_name)
      team.name = row.teamName || row.team_name;
    return team;
  };
  ["leaderboard", "progress", "cooperation", "games", "rooms"].forEach((key) =>
    (data[key] || []).forEach(ensure),
  );
  (data.leaderboard || []).forEach((row) => {
    const team = ensure(row);
    if (team)
      Object.assign(team, {
        success: number(row.success_rate),
        speed: number(row.speed_score),
        attempts: number(row.attempts),
      });
  });
  (data.progress || []).forEach((row) => {
    const team = ensure(row);
    if (team)
      Object.assign(team, {
        progress: number(row.progress),
        required: number(row.required),
        pieces: row.placedIndexes || [],
        puzzle: number(row.progressPct),
      });
  });
  (data.cooperation || []).forEach((row) => {
    const team = ensure(row);
    if (team)
      Object.assign(team, {
        coop: number(row.coop_score),
        active: number(row.active_players),
        actions: number(row.total_actions),
      });
  });
  const players = (data.players || []).map((row) => {
    const team = ensure(row);
    const player = {
      id: String(row.userId),
      name: row.userName || `Uczestnik ${row.userId}`,
      team: team?.id,
      school: team?.name || "Brak przypisanej drużyny",
      success: number(row.success_rate),
      speed: number(row.speed_score),
      attempts: number(row.attempts),
      mvp: number(row.mvp_score),
    };
    if (team) team.players.push(player);
    return player;
  });
  return { teams: [...teams.values()], players };
}
export function rankRows(rows, metric, minimum = 0) {
  let previous,
    rank = 0;
  return rows
    .filter(
      (row) =>
        minimum <= 0 || (row.attempts !== null && row.attempts >= minimum),
    )
    .slice()
    .sort(
      (a, b) =>
        (b[metric] ?? -Infinity) - (a[metric] ?? -Infinity) ||
        a.name.localeCompare(b.name, "pl"),
    )
    .map((row, index) => {
      if (index === 0 || row[metric] !== previous) rank = index + 1;
      previous = row[metric];
      return { ...row, rank: row[metric] == null ? null : rank };
    });
}
export function weightedSuccess(rows) {
  const valid = rows.filter((row) => row.success != null && row.attempts > 0);
  const count = valid.reduce((sum, row) => sum + row.attempts, 0);
  return count
    ? valid.reduce((sum, row) => sum + row.success * row.attempts, 0) / count
    : null;
}
export function csvCell(value) {
  let text = value == null ? "" : String(value);
  if (/^[=+\-@\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}
